export const shadesOfGreen = [
    '#009640',
    '#9BCFB2',
    '#CEE6D7',
]
export const shadesOfBlue = [
    '#58ABC6',
    '#C6DDEA',
    '#E3EEF4',
]
export const shadesOfRed = [
    '#A52431',
    '#C6183E',
    '#FBDAD5',
    '#F08480',
    '#FBDAD5',
]

export const shadesOfOrange = [
    '#D2241C',
    '#E2411F',
    '#E6601F',
    '#EE892D',
    '#F8C4A3',
]

export const shadesOfTeal = [
    '#00899D',
    '#00A8AC',
    '#46B9B0',
    '#A4D6D1',
    '#C6E4E1',
]

export const shadesOfYellow = [
    '#F18700',
    '#F7A600',
    '#FDC300',
    '#FFDD00',
    '#FFEA80',
]

export const shadesOfPurple = [
    '#4D1C6B',
    '#702283',
    '#8E2F89',
    '#B783B9',
    '#E5D7EB',
]

export const shadesOfMoave = [
    '#30358C',
    '#5554A0',
    '#7E7AB8',
    '#A8A5D2',
    '#D3D1EA',
]

export const darkShades = [
    '#009640',
    '#58ABC6',
    '#A52431',
    '#D2241C',
    '#00899D',
    '#4D1C6B',
    '#30358C',

]